import React, { useState } from "react";
import { Button, Nav, Col, Row, Tab, Form } from "react-bootstrap";
import { SliderPanel, FieldInput } from "../../components";
import { get } from "lodash";
import { faTrashAlt, faAngleLeft } from "@fortawesome/pro-light-svg-icons";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//import Drawer from "react-bottom-drawer";

function ResponsiveSlideout(props) {
  const {
    slideOutOpen,
    setSlideOutOpen,
    title = "",
    drawerClassName = "drawer-100",
    webSlidoutWidth = "55",
    buttonList = [],
    showPenIcon,
    resetForm,
    setTableError,
    ...rest
  } = props;

  const handleCancel = () => {
    resetForm();
    setSlideOutOpen(false);
    setTableError("");
  };
  return (
    <>
      <div className="d-none d-sm-block">
        <SliderPanel
          isOpen={slideOutOpen}
          size={webSlidoutWidth}
          showCancel={false}
          {...rest}
        >
          <div className="web-slider-pannel-head">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div
                style={{ fontSize: "18px", fontWeight: "500" }}
                className="responsive-slideout-title"
              >
                {title}
              </div>
              <div style={{ display: "flex" }}>
                {buttonList
                  .slice()
                  .reverse()
                  .map((_, ind) => {
                    return (
                      <Button
                        onClick={
                          _.label === "Cancel" ? handleCancel : _.onClick
                        }
                        variant={get(_, "variant", "primary")}
                        style={{ marginLeft: "20px" }}
                        type={get(_, "type", "button")}
                      >
                        {_.label}
                      </Button>
                    );
                  })}
              </div>
            </div>
            <hr />
          </div>
          {props.children}
        </SliderPanel>
      </div>
      <div className="d-block d-sm-none mobile-responsive-slideout">
        {/* <SliderPanel type='bottom' isOpen={slideOutOpen} size={mobileSlidoutHeight} showCancel={false}> */}
        {/* <Drawer
          duration={250}
          hideScrollbars={true}
          onClose={() => setSlideOutOpen(false)}
          isVisible={slideOutOpen}
          className={drawerClassName}
        > */}
        <div className="web-slider-pannel-head">
          <div
            style={{ alignItems: "center" }}
            className="d-flex  responsive-slideout-title"
          >
            <FontAwesomeIcon
              icon={faAngleLeft}
              onClick={() => {
                setSlideOutOpen(false);
              }}
              size="lg"
            />
            <div style={{ fontSize: "18px", fontWeight: "500" }}>{title}</div>
            {showPenIcon && (
              <div className="ms-auto" onClick={() => {}}>
                <FontAwesomeIcon icon={faPen} color="#000000" size="lg" />
              </div>
            )}
          </div>
          <hr />
        </div>
        <div style={{ marginTop: "20px" }}>{props.children}</div>
        <div className="mt-auto">
          {buttonList.map((_, ind) => {
            return (
              <Button
                onClick={_.onClick}
                variant={get(_, "variant", "primary")}
                className="mt-3 w-100"
                type={_.type}
              >
                {_.label}
              </Button>
            );
          })}
        </div>
        {/* / </Drawer> */}
        {/* </SliderPanel> */}
      </div>
    </>
  );
}

export default ResponsiveSlideout;
